/**
 * HomePage Component
 * Main page with header, search, and link grid
 */

import { useState } from "react";
import { Header } from "../components/Header";
import { LinkGrid } from "../components/LinkGrid";
import { AddLinkDialog } from "../components/AddLinkDialog";

export function HomePage() {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleLinkAdded = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header onAddClick={() => setIsAddDialogOpen(true)} />

      <main className="px-4 py-6 md:px-6 md:py-8">
        <LinkGrid
          refreshKey={refreshKey}
          onAddClick={() => setIsAddDialogOpen(true)}
        />
      </main>

      <AddLinkDialog
        open={isAddDialogOpen}
        onOpenChange={setIsAddDialogOpen}
        onSuccess={handleLinkAdded}
      />
    </div>
  );
}
